import { COLORS } from '@/constants/styles';

export const MAIN_LAYOUT_INFO = {
  backgroundColor: COLORS.grayscale.gray50,
};

export const SUB_LAYOUT_INFO = {
  backgroundColor: COLORS.grayscale.white,
};
